// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import Router from 'next/router';
import * as Enums from '@/utils/enums';
import BillingService from '@/services/billing-service';
import Helper from '@/utils/helper';
import SubscriptionContext from '@/utils/subscription-context';
import SettingsMenu from '@/components/settings/menu';
import ManageFormDefinition from "@/PageComponents/Settings/ManageFormDefinition";
import { createFileRoute } from '@tanstack/react-router'



const initialFormDefinition = {
  FormDefinitionStatus: Enums.FormDefinitionStatus.Draft
};

const CreateFormDefinition = () => {

  let currPath = '';
  if (Router.router) {
    currPath = Router.router.asPath;
  }

  const subscriptionContext = useContext(SubscriptionContext);
  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
  /*const [formDefinition, setFormDefinition] = useState({
    FormDefinitionStatus: Enums.FormDefinitionStatus.Draft
  });*/

  const getAccessStatus = async () => {
    const [subscriptionInfo, message] = await BillingService.getSubcriptionInfo(subscriptionContext);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  useEffect(() => {
    getAccessStatus();
  }, []);
  
  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace,"/");
    }
  }, [accessStatus]);

  return (
    <div className="settings-container">
      {/*<div className="row">
        <div className="title">
          <Breadcrumbs
            crumbs={[
              { text: 'Settings', link: '', suppressLink: true },
              { text: 'Forms', link: '/settings/form/list' },
              { text: 'Create Form', link: '/settings/form/create' },
            ]}
          />
        </div>
      </div>*/}
      <div className="row">
        <SettingsMenu urlPath={currPath} />
        <div className="settings-card">
          <ManageFormDefinition formDefinition={initialFormDefinition} isNew={true} accessStatus={accessStatus} />
          {/*<LegacyManageFormDefinition formDefinition={formDefinition} setFormDefinition={setFormDefinition} isNew={true} accessStatus={accessStatus} />*/}
        </div>
      </div>

      <style jsx>{`
        .row {
          display: flex;
        }
        .column {
          display: flex;
          flex-basis: 0;
          flex-direction: column;
          flex-grow: 1;
        }
        .column :global(.textarea-container) {
          height: 100%;
        }
        .column + .column {
          margin-left: 1.25rem;
        }
      `}</style>
    </div>
  );
};

export default CreateFormDefinition;

export const Route = createFileRoute('/_authenticated/settings/form/create')({ component: CreateFormDefinition })
